import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getCustomerWallets = ({ customerId }) => {
  return axios.get(`/customer/wallets/${customerId}`);
};

export const useCustomerWallets = ({ customerId, config }) => {
  return useQuery({
    ...config,
    queryKey: ['customerWallets'],
    queryFn: () => getCustomerWallets({ customerId }),
  });
};
